import { gql } from '../../__generated__/gql'

export const COMMUNITY_TOGGLE_FEATURED_POST_MUTATION = gql(`
    mutation toggleFeaturePost( $postId: Int! ) {
      toggleFeaturedPost(input: { postId: $postId }) {
        communityPost {
          id
          featured
        }
      }
    }
`)
